module.exports = __webpack_public_path__ + "img/tema-1-8.cb8bc400.svg";